window._fpImage = window._fpImage || [];
window._fpImage.prefetch = window._fpImage.prefetch || function(...arguments) {
    function isValidHttpUrl(string) {
        let url;

        try {
            url = new URL(string);
        } catch (_) {
            return false;
        }

        return url.protocol === "http:" || url.protocol === "https:";
    }

    arguments.forEach((item) => {
        if (isValidHttpUrl(item) && _fpImage.indexOf('__' + item) === -1) {

            const linkNode = document.createElement('link');
            linkNode.rel = 'preload';
            linkNode.as = 'image';
            linkNode.href = item;
            document.head.insertAdjacentElement('beforeend', linkNode);

            window._fpImage.push('__' + item);
        }
    });
};
if (window.location.pathname === "/") window.innerWidth < 1024 ? window._fpImage.prefetch('https://cdn.shopify.com/s/files/1/0797/7215/files/hp_mobile_1.jpg?v=1702672085') : window._fpImage.prefetch('https://cdn.shopify.com/s/files/1/0797/7215/files/Group_2_1_1.png?v=1702907706');